import React from 'react'
import { PageAdditionalProps } from 'page-lifecycle-provider'
import { useSelector } from 'react-redux'
import { AppState } from 'common/store'

export const UserAnalytics: React.FC = () => {
    const {
        gigyaId,
        isLoggedIn,
        loginProvider,
        socialProviders,
        occupantId,
        entitlements,
    } = useSelector((state: AppState) => state.authentication)

    return (
        <PageAdditionalProps
            pageProperties={toGtmShape(
                gigyaId,
                loginProvider,
                socialProviders,
                isLoggedIn,
                occupantId,
                entitlements
            )}
        />
    )
}

UserAnalytics.displayName = 'InternalUserAnalytics'

export function toGtmShape(
    gigyaId: string,
    loginProvider: string,
    socialProviders: string,
    isLoggedIn: boolean,
    occupantId: string | undefined,
    entitlements: string[]
) {
    return {
        gigya: gigyaId,
        loginProvider,
        socialProviders,
        loggedInStatus: getLoggedInStatus(isLoggedIn),
        dti: occupantId || '',
        entitlements,
    }
}
export function getLoggedInStatus(isLoggedIn: boolean) {
    return isLoggedIn ? 'Logged in' : 'Logged out'
}
